import { SB } from '@play-co/replicant';
import competitionSchema from './competition/competition.schema';

// Store combined accumulated rewards before user claim it over actions
const rewards = SB.object({
  bpoints: SB.int().min(0),
  energy: SB.int().min(0),
  gems: SB.int().min(0),
  bronze: SB.int().min(0),
  silver: SB.int().min(0),
});

// Single event state
const event = SB.object({
  startedAt: SB.int().default(0).min(0),
  updatedAt: SB.int().default(0).min(0),
  // Current frenzy event milestone level
  level: SB.int().default(0).min(0),
  // Cumulative current frenzy event progress
  progress: SB.int().default(0).min(0),
  // Unclaimed rewards, waiting for user to claim it
  rewards: rewards.optional(),
  // Progression table used for this event
  progression: SB.string().default('control'),
  // Frenzy competition data
  competition: competitionSchema,
});

// Export types
export type FrenzyEventState = SB.ExtractType<typeof event>;
export type FrenzyRewardsState = SB.ExtractType<typeof rewards>;

// Export main schema
export default {
  // Map frenzy event ID to event state object
  frenzy: SB.map(event).optional(),
  // Count of old frenzy events the user participated in.
  frenzyEventsCount: SB.int().default(0).min(0).optional(),
};
